import { atom } from "jotai";

import type { Feature } from "@/components/map/draw-control";

export const currentFeatureAtom = atom<Feature | null>(null);
